<div class="delete-account-modal" piTesting="deleteAccountModal">
    <div class="tapestry-title title--sm delete-account-modal__header">
        {{
            'platform.seller-tools-peek.accounts.delete-modal.title'
                | translateFormat: dialogData.accountName
        }}
        <tapestry-icon-button
            iconName="close_page"
            mat-dialog-close
            [iconTheme]="IconTheme.Light"
        ></tapestry-icon-button>
    </div>
    <div class="modal-description-text tapestry-body body--md">
        <div class="delete-account-modal__body-text">
            {{
                'platform.seller-tools-peek.accounts.delete-modal.body'
                    | translate
            }}
        </div>
    </div>
    <div class="modal-actions">
        <tapestry-button
            [text]="'text.common-terms.cancel' | translate"
            color="tertiary"
            (buttonClicked)="cancel($event)"
            [disabled]="saving"
            trackingName="accountDeleteCancel"
        ></tapestry-button>
        <tapestry-button
            [text]="
                'platform.seller-tools-peek.accounts.delete-modal.save-action'
                    | translate
            "
            color="primary"
            (buttonClicked)="save($event)"
            [disabled]="saving"
            [loading]="saving"
            trackingName="accountDeleteConfirm"
        ></tapestry-button>
    </div>
</div>
